// @flow

import { connect } from 'react-redux';
import ScribeTranscript from './ScribeTranscript';
import { scribeSelectTranscriptWord } from '../../actions';

const emptyArray = [];

const mapStateToProps = (state, { id }) => {
  const {
    scribeTranscriptUI: { fontSize, wordBeingEdited, electronCaptionMode },
    scribeConversation: {
      speakers,
      ui: { selectedTranscriptIndex, selectedWordIndex },
      muted,
      lang,
      scribe,
      status,
    },
    scribeSession: { currentPlatform, socketConnectionStatus, captioner, lightView },
  } = state;

  const {
    [id]: {
      texts,
      highlighted,
      speechLang,
      cursors,
      isFinal,
      mutationsQueuedByHumanMutation,
      indexes,
      author,
      authorShow,
      trackName,
    },
  } = state.scribeConversation.transcripts;
  const cursorsSize = (cursors || []).map(cursor => cursor.index).filter(i => i >= 0).length;
  return {
    author,
    authorShow,
    electronCaptionMode,
    scribe,
    currentPlatform,
    cursors,
    fontSize,
    highlighted,
    id,
    isFinal,
    isSelected: selectedTranscriptIndex === id,
    lang,
    mutationsQueuedByHumanMutation: mutationsQueuedByHumanMutation?.length
      ? mutationsQueuedByHumanMutation
      : emptyArray,
    muted,
    participantsHash: status.participants && cursorsSize ? status.participants : undefined,
    selectedWordIndex: selectedTranscriptIndex === id ? selectedWordIndex : 0,
    socketConnectionStatus,
    speaker: speakers[author],
    singleSpeaker: Object.keys(speakers).length === 1,
    speechLang,
    texts,
    trackName,
    userAvaId: captioner?.avaId || '',
    userName: captioner?.userName || '',
    userScribeFlag: captioner?.features?.scribe || false,
    lightView,
    wordBeingEdited: selectedTranscriptIndex === id ? wordBeingEdited : false,
    indexes,
  };
};

export default connect(mapStateToProps, { scribeSelectTranscriptWord })(ScribeTranscript);
